<template lang="pug">
.auto-renew-container(v-if="show", @touchmove.prevent)
  .auto-block
    .auto-close(@click="close")
      img.close(src="https://m.hellobike.com/resource/helloyun/08345/Pe7OEngKfX.png?x-oss-process=image/quality,q_80")
    .auto-word 确定要关闭自动续费吗？
    .auto-btn
      .auto-btn-left(@click="cancelSign") 直接关闭
      .auto-btn-right(@click="close") 继续享用
        .more-choose 95%用户的选择
  .shadow
  </template>
<script>
import {
  cancelSignIn, getRedirectUrl,
} from '@/api/vip';
import {
  getTokenAndKey,
} from '@/utils';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env } from '@hb/hbridge';
import { getVersion } from '@/utils/systemCode';
import Loading from '@/components/loading';
import config from '@/const/config';
import { ParamsUtil } from '../../../../utils/params';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    userNewId: {
      type: Number,
      default: 0,
    },
    isSign: {
      type: Boolean,
      require: true,
    },
    cancelSignDelay: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      env,
      version: '',
      isNew: null,
    };
  },
  watch: {
  },
  async created() {
    this.version = await getVersion();
    const { isNew } = this.$route.query;
    this.isNew = isNew;
  },
  mounted() {
    // this.$router.replace('/vip/v2?isRenew=true');
  },
  destroyed() {
  },
  methods: {
    async cancelSign() {
      Loading.show('加载中');
      UBT.clickButton({
        pageId: 'platform_guanlixufei_page',
        buttonName: 'platform_zhijieguanbi',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndKey();


      try {
        const res = await cancelSignIn({
          token,
          appCode: 'platform',
        });
        if (res.data) {
          Loading.close();
          setTimeout(() => {
            this.$emit('refresh');
          }, this.cancelSignDelay);

          this.$emit('update:show', false);
        } else {
          Loading.close();
        }
      // eslint-disable-next-line no-empty
      } catch {
        Loading.close();
      }
    },
    close() {
      UBT.clickButton({
        pageId: 'platform_guanlixufei_page',
        buttonName: 'platform_jixuxiangyong',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="less" scoped>
.auto-renew-container {
  .auto-block {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 330;
    width: 3.2rem;
    height: 1.45rem;
    background: #fff;
    border-radius: 0.12rem;

    .auto-close {
      position: absolute;
      right: 0.13rem;
      top: 0.13rem;

      img.close {
        width: 0.14rem;
        height: 0.14rem;
      }
    }

    .auto-word {
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      font-size: 0.18rem;
      color: #242729;
      text-align: center;
      padding-top: 0.28rem;
    }

    .auto-btn {
      padding: 0 0.2rem;
      margin-top: 0.26rem;
      display: flex;
      justify-content: space-around;

      .auto-btn-left {
        width: 1.36rem;
        height: 0.4rem;
        background: #f3f3f4;
        border-radius: 0.08rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.18rem;
        color: #242729;
        line-height: 0.4rem;
        text-align: center;
      }

      .auto-btn-right {
        width: 1.36rem;
        height: 0.4rem;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        border-radius: 0.08rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        font-size: 0.18rem;
        color: #fff;
        line-height: 0.4rem;
        text-align: center;
        position: relative;

        .more-choose {
          position: absolute;
          top: -0.2rem;
          left: 0.2rem;
          width: 0.94rem;
          height: 0.3rem;
          background-image: url(https://m.hellobike.com/resource/gallery/61/u0Uz_Dvplo.png?x-oss-process=image/quality,q_80);
          background-size: 100% 100%;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.12rem;
          color: #441d06;
          line-height: 0.26rem;
          text-align: center;
          border-radius: 0.08rem;
        }
      }
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 300;
  }
}
</style>
